module.exports = __webpack_public_path__ + "static/media/rickIcon.956fd15e.png";